module.exports = __webpack_public_path__ + "3f8fe741dadbe5462719dedc4292879e.pdf";